var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.643 11.152 7.53 2.956A1 1 0 0 0 6 3.804v16.392a1 1 0 0 0 1.53.848l13.113-8.196a1 1 0 0 0 0-1.696Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};

export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjY0MzIgMTEuMTUyTDcuNTMgMi45NTYyNUM2Ljg2Mzk1IDIuNTM5OTcgNiAzLjAxODgxIDYgMy44MDQyNVYyMC4xOTU4QzYgMjAuOTgxMiA2Ljg2Mzk1IDIxLjQ2IDcuNTMgMjEuMDQzOEwyMC42NDMyIDEyLjg0OEMyMS4yNjk5IDEyLjQ1NjMgMjEuMjY5OSAxMS41NDM3IDIwLjY0MzIgMTEuMTUyWiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";